import { useCallback, useEffect, useState } from "preact/hooks";
import axios from "axios";

export default function useBlacklists() {
    const [blacklists, setBlacklists] = useState([]);

    const [isLoading, setIsLoading] = useState(false);

    const fetchBlacklists = useCallback(async () => {
        setIsLoading(true);
        try {
            axios.get("/user/kyc/blacklist").then((response) => {
                setBlacklists(response.data);
                setIsLoading(false);
            });
        } catch (error) {
            console.error(error);
            setIsLoading(false);
        }
    }, []);

    const deleteBlacklist = useCallback(async (list_name) =>{
        setIsLoading(true);
        try {
            axios.delete(`/user/kyc/blacklist/${list_name}/file`)
            .then(response =>{
                fetchBlacklists();
                setIsLoading(false);
            })
        } catch (error) {
            console.error(error);
            setIsLoading(false);
        }
    });

    useEffect (() => {
        fetchBlacklists();
    }, []);

    return { blacklists, fetchBlacklists, deleteBlacklist, isLoading };
}